import styled from 'styled-components'
import { device } from 'Rentlio/style/responsive'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  background: ${props => props.theme.colors.notePromotoBg};
  border: 1px solid ${props => props.theme.colors.secondary};
  padding: 30px 50px;
  box-sizing: border-box;
  margin: 70px auto 0px auto;
  max-width: 1180px;

  @media ${device.mobile} {
    flex-direction: column;
    margin: 50px 30px 30px 30px;
    padding: 30px;
  }

  @media ${device.tablet} {
    flex-direction: column;
    margin: 50px 30px 30px 30px;
    padding: 30px;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 40px;

  @media ${device.mobile} {
    width: 100%;
    margin-bottom: 20px;
  }

  @media ${device.tablet} {
    width: 100%;
    margin-bottom: 20px;
  }
`

export const NoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  white-space: break-spaces;
  padding-left: 50px;
  box-sizing: border-box;
  font-weight: ${props => props.theme.fonts.regularWeight};
  font-size: ${props => props.theme.fonts._14};
  line-height: ${props => props.theme.fonts._24};
  color: ${props => props.theme.colors.textColor};
  opacity: 0.8;

  @media ${device.mobile} {
    padding-left: 0px;
    font-size: ${props => props.theme.fonts._12};
    line-height: ${props => props.theme.fonts._20};
  }

  @media ${device.tablet} {
    padding-left: 0px;
    font-size: ${props => props.theme.fonts._12};
    line-height: ${props => props.theme.fonts._20};
  }
`
